module.exports = __webpack_public_path__ + "images/district_back.1789545008192.png";